import { COPY_STRINGS } from "../constants/translatedCopy";

export function generateSayWordSpelledMakesWordString(word) {
    const wordSpelled = generateSpelledWordSpeechString(word)
    return COPY_STRINGS.intervention_strings.ok + " " + wordSpelled + " " + COPY_STRINGS.intervention_strings.makes + " " + word
}

export function generateSpelledWordSpeechString(word) {
    return "<prosody rate=\"slow\"><say-as interpret-as=\"spell-out\">" + word + "</say-as></prosody>";
}